import { Component, OnInit } from '@angular/core';
import { LambdaService } from '../services/lambda.service';
import { CommonModule } from '@angular/common';
import * as rutility from 'rutility'
import { FormsModule } from '@angular/forms';
import { RecaptchaService } from '../services/recaptcha.service';
import { DataService } from '../services/data.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-rut-form',
  standalone: true,
  imports: [CommonModule, FormsModule, MatProgressSpinnerModule],
  templateUrl: './rut-form.component.html',
  styleUrl: './rut-form.component.css'
})
export class RutFormComponent implements OnInit {

  get error() { return this.dataService.errors.input; }
  get isLoading() { return this.dataService.loading; }

  errorInput: string = 'ok';
  showErrorInput: boolean = false;
  rut: string = '';
  lastSearchedRut: string = '';

  constructor(
    private lambdaService: LambdaService,
    private recaptcha: RecaptchaService,
    private dataService: DataService,
  ) {
  }

  ngOnInit() {
  }

  public async getOrdersAndCustomer(formattedRut: string, recaptchaToken: string) {
    const response = await this.lambdaService.invokeGetOrders(formattedRut, recaptchaToken);
    if (response.error) throw new Error(response.error);
    this.dataService.orders = response.orders;
    this.dataService.customer = response.customer;
    if (!this.dataService.orders.some(order => order.hasSubscription)) throw new Error('No se encontraron órdenes con suscripciones activas');
  }

  isValidRut(rut: string): boolean {
    try {
      const cleanRut = rutility.format.notDotDash(rut);
      if (cleanRut.length < 7) { 
        this.errorInput = "RUT demasiado corto";
        return false
      };
      if (cleanRut.length > 9) { 
        this.errorInput = "RUT demasiado largo";
        return false
      };
      const formattedRut = rutility.format.dotDash(rut);
      const isValid = rutility.isValidRut(formattedRut);
      if (!isValid) {
        this.errorInput = "RUT inválido";
        return false;
      }
      this.showErrorInput = true;
      this.errorInput = 'ok';
      return true;
    } catch (error) {
      this.errorInput = "RUT inválido";
      return false;
    }
  }

  async onSubmit() {
    this.dataService.loading = true;
    try {

      // validar rut
      const formattedRut = rutility.format.dotDash(this.rut);
      if (this.lastSearchedRut === formattedRut) throw new Error('Ya has buscado este RUT');
      if (this.dataService.customer?.taxId && rutility.format.dotDash(this.dataService.customer.taxId) === formattedRut) throw new Error('Ya has buscado este RUT');
      if (!rutility.isValidRut(formattedRut)) throw new Error('RUT inválido');
      this.lastSearchedRut = formattedRut;
      
      // llamada al backend
      this.dataService.reset();
      const token_getOrdersAndCustomer = await this.recaptcha.execute('getOrdersAndCustomer');
      await this.getOrdersAndCustomer(formattedRut, token_getOrdersAndCustomer);
      this.dataService.step = 2;
      this.dataService.loading = false;

    } catch (error) {
      console.error('Error', error);
      this.dataService.errors.input = "Rut no encontrado o sin subscripciones activas";
      this.dataService.step = 1;
      this.dataService.loading = false;
    }

  }
}